import { FormTextAreaField, FormTextField } from '@components/FormFields';
import { Typography, Stack } from '@mui/material';
import { useContext } from 'react';
import { DisableContext } from '../DisableContext';
import { RowInformation } from '@components/RowInformation';
import { useFormContext } from 'react-hook-form';
import { buildFullDataTestId, DATA_TEST_ID_SELECTION } from '@src/utils';

export const GeneralInformation = () => {
  const { control, getValues } = useFormContext();
  const disabled = useContext(DisableContext);

  const dataTestId = buildFullDataTestId(DATA_TEST_ID_SELECTION);

  const { name, referenceLink, internalDescription, patientDescription } = getValues();

  const common = {
    disabled,
    control,
    dataTestId,
  };

  return (
    <Stack gap="48px" padding="36px" bgcolor="#FFFFFF" width="30%" maxWidth="430px" height="100%">
      <Stack gap="24px">
        <Typography color="grey.700" variant="head24Medium" lineHeight="34px">
          {`General${disabled ? ' information' : ''}`}
        </Typography>
        {disabled ? (
          <Stack gap="18px">
            <RowInformation name="Name" value={name} />
            <RowInformation name="Reference link" value={referenceLink} isLink={true} />
            <RowInformation name="Professional description" value={internalDescription} />
            <RowInformation name="Patient description" value={patientDescription} />
          </Stack>
        ) : (
          <>
            <FormTextField name="name" label="Name" required maxLength={255} withErrorMessage {...common} />
            <FormTextField
              name="referenceLink"
              label="Reference link"
              required
              withErrorMessage
              maxLength={2048}
              {...common}
            />
          </>
        )}
      </Stack>
      {disabled ? null : (
        <Stack gap="48px">
          <FormTextAreaField name="internalDescription" label="Professional description" {...common} />
          <FormTextAreaField name="patientDescription" label="Patient description" {...common} />
        </Stack>
      )}
    </Stack>
  );
};
